module.exports = __webpack_public_path__ + "static/logo-dome-blue-4ce1f9cd4f4c5126b250b3374eda495d.png";